import React from 'react';
import ContextMenu from '@avtechsoftware/react-component-library/src/components/common/ContextMenu/ContextMenu';
import ContextMenuItem
  from '@avtechsoftware/react-component-library/src/components/common/ContextMenu/ContextMenuItem/ContextMenuItem';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import HasRolePrivileges from '../../../../../highorder/HasRolePrivileges';
import { RaaRoles } from '../../../../../../utility/SecurityRules';
import { connectModalContainerContextToComponent } from '../../../../../../contexts/ModalContext/ModalContext';
import NotificationTemplatePropType from '../../../../../../utility/PropTypes/notificationTemplatePropType';
import DeleteConfirmationModal from '../../../../../common/DeleteConfirmationModal';
import {
  deleteNotificationTemplate,
} from '../../../../../../redux/slices/notificationTemplatesSlice/notificationTemplatesSlice';
import CannotDeleteInUseModal from '../../../../../common/CannotDeleteInUseModal';
import { BulkAlertingResourceType } from '../../../../../../utility/types/BulkAlertingResourceType';
import { setAppliedAlertSearch } from '../../../../../../redux/slices/alertListSlice/alertListSlice';
import FacetId from '../../../../../../utility/types/facetType';

function NotificationTemplateListTableRow({ notificationTemplate, setModalJSX }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const getUsedInCount = () => notificationTemplate.uniqueAlertCount;

  const getIncludesString = () => {
    const includesEmail = 'Customized Email Template';
    const includesSms = 'Customized SMS Template';
    if (!notificationTemplate.useDefaultEmailTemplate
        && !notificationTemplate.useDefaultSmsTemplate) {
      return `${includesEmail} and ${includesSms}`;
    }
    if (!notificationTemplate.useDefaultEmailTemplate) {
      return includesEmail;
    }
    if (!notificationTemplate.useDefaultSmsTemplate) {
      return includesSms;
    }
    return '';
  };

  const handleSafeDelete = (event) => {
    event.stopPropagation();
    const isInUse = getUsedInCount();
    if (isInUse && isInUse > 0) {
      setModalJSX(
        <CannotDeleteInUseModal
          itemName={notificationTemplate.name}
          itemType={BulkAlertingResourceType.NOTIFICATION_TEMPLATE}
        />,
      );
    } else {
      setModalJSX(
        <DeleteConfirmationModal
          itemName={notificationTemplate.name}
                // isButtonDisabled={deleteInProgress}
          handleDelete={() => {
            dispatch(deleteNotificationTemplate(notificationTemplate.id));
            setModalJSX(<></>);
          }}
        />,
      );
    }
  };

  return (
    <tr>
      <td className="ellipsis width-25">
        <span className="ml-1">
          {notificationTemplate.name}
        </span>
      </td>
      <td className="ellipsis width-25" title="">
        <span className="ml-1 pr-1">
          {getIncludesString()}
        </span>
      </td>
      <td className="width-15">
        <span className="ml-1">
          <button
            type="button"
            className="btn btn-link p-0"
            title=""
            onClick={async () => {
              await dispatch(setAppliedAlertSearch({
                filters: [{
                  id: null,
                  facetId: FacetId.ALERT_NOTIFICATION_TEMPLATES,
                  operatorId: OperatorTypes.EQUAL_TO_VALUE,
                  value1: notificationTemplate.id.toString(),
                }],
              }));
              history.push('/s/alerts');
            }}
          >
            {getUsedInCount() || 0}
            {' '}
            {getUsedInCount() === 1 ? 'alert' : 'alerts'}
          </button>
        </span>
      </td>
      <td className="width-10">
        <ContextMenu classname="overflow-visible">
          <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
            <>
              <ContextMenuItem
                itemIcon="pencil"
                itemText="Edit"
                onClickHandler={(event) => {
                  event.stopPropagation();
                  history.push(
                    `/s/actions/notification-templates/edit/${notificationTemplate.id}`,
                  );
                }}
              />
              <ContextMenuItem
                itemIcon="copy"
                itemText="Clone"
                onClickHandler={(event) => {
                  event.stopPropagation();
                  history.push(
                    `/s/actions/notification-templates/clone/${notificationTemplate.id}`,

                  );
                }}
              />
              <ContextMenuItem
                itemIcon="trash"
                itemText="Delete"
                onClickHandler={(event) => handleSafeDelete(event)}
              />
            </>
          </HasRolePrivileges>
        </ContextMenu>
      </td>
    </tr>
  );
}

NotificationTemplateListTableRow.propTypes = {
  notificationTemplate: PropTypes.shape(NotificationTemplatePropType).isRequired,
  setModalJSX: PropTypes.func.isRequired,
};

export default connectModalContainerContextToComponent(NotificationTemplateListTableRow);
